/*
  "Done" control — a checkbox in the GitHub "Viewed" sense, not a button: it
  reports a state the user owns rather than triggering an action, so the whole
  shell is one label-wrapped hit target.
*/
import { cn } from "@/lib/utils";
import { useTranslation } from "@repo/shared/i18n";

import { CheckBox } from "../Check/Check";

export const DoneCheckbox = ({
  checked,
  onChange,
  label,
  className,
}: {
  checked: boolean;
  onChange: () => void;
  label?: string;
  className?: string;
}) => {
  const { t } = useTranslation();
  return (
    <label
      className={cn(
        "inline-flex items-center gap-2 rounded-lg border px-3 py-1.5 cursor-pointer select-none",
        "min-h-8 touch-device:min-h-8",
        /* Checked recedes to the page colour, which is also the even rows'
           background, so its border must sit a step lighter to stay an outline. */
        checked
          ? "bg-streamline-page border-neutral-700"
          : "bg-neutral-800 border-neutral-600 hover:border-neutral-500 hover:bg-neutral-750",
        className,
      )}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="sr-only"
      />
      <CheckBox
        checked={checked}
        className={cn(!checked && "border-neutral-500")}
      />
      <span
        className={cn(
          "text-xs font-bold",
          checked ? "text-neutral-500" : "text-white",
        )}
      >
        {label ?? t("done")}
      </span>
    </label>
  );
};

export default DoneCheckbox;
